import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, call, xClient } from "@/api/spec";
import { qk } from "@/api/queryKeys";
import type { Me } from "@/api/types";
import { useAuthStore } from "@/stores/authStore";

/** GET /api/me(1.16). 성공하면 authStore(잔액·프로필·공지)를 갱신한다. 실패하면 화면이 authStore 캐시를 쓴다. */
export function useMe(enabled = true) {
  const query = useQuery({
    queryKey: qk.me,
    queryFn: () => call(api.GET("/me", { params: { header: xClient() } })),
    enabled,
    staleTime: 0,
  });
  const me: Me | undefined = query.data;
  useEffect(() => {
    if (me) useAuthStore.getState().setMember(me);
  }, [me]);
  return query;
}
